"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    backgroundPaletteVariants: ()=>backgroundPaletteVariants
});
const external_tv_cjs_namespaceObject = require("../tv.cjs");
const external_basePaletteVariants_cjs_namespaceObject = require("./basePaletteVariants.cjs");
const backgroundPaletteVariants = (0, external_tv_cjs_namespaceObject.tv)({
    variants: {
        palette: external_basePaletteVariants_cjs_namespaceObject.allPaletteVariants,
        shade: external_basePaletteVariants_cjs_namespaceObject.allPaletteShades
    },
    defaultVariants: {
        shade: '8'
    },
    compoundVariants: [
        {
            palette: 'primary',
            shade: '1',
            class: 'bg-primary-1'
        },
        {
            palette: 'primary',
            shade: '2',
            class: 'bg-primary-2'
        },
        {
            palette: 'primary',
            shade: '3',
            class: 'bg-primary-3'
        },
        {
            palette: 'primary',
            shade: '4',
            class: 'bg-primary-4'
        },
        {
            palette: 'primary',
            shade: '5',
            class: 'bg-primary-5'
        },
        {
            palette: 'primary',
            shade: '6',
            class: 'bg-primary-6'
        },
        {
            palette: 'primary',
            shade: '7',
            class: 'bg-primary-7'
        },
        {
            palette: 'primary',
            shade: '8',
            class: 'bg-primary-8'
        },
        {
            palette: 'primary',
            shade: '9',
            class: 'bg-primary-9'
        },
        {
            palette: 'primary',
            shade: '10',
            class: 'bg-primary-10'
        },
        {
            palette: 'primary',
            shade: '11',
            class: 'bg-primary-11'
        },
        {
            palette: 'primary',
            shade: '12',
            class: 'bg-primary-12'
        },
        {
            palette: 'primary',
            shade: '13',
            class: 'bg-primary-13'
        },
        {
            palette: 'neutral',
            shade: '1',
            class: 'bg-neutral-1'
        },
        {
            palette: 'neutral',
            shade: '2',
            class: 'bg-neutral-2'
        },
        {
            palette: 'neutral',
            shade: '3',
            class: 'bg-neutral-3'
        },
        {
            palette: 'neutral',
            shade: '4',
            class: 'bg-neutral-4'
        },
        {
            palette: 'neutral',
            shade: '5',
            class: 'bg-neutral-5'
        },
        {
            palette: 'neutral',
            shade: '6',
            class: 'bg-neutral-6'
        },
        {
            palette: 'neutral',
            shade: '7',
            class: 'bg-neutral-7'
        },
        {
            palette: 'neutral',
            shade: '8',
            class: 'bg-neutral-8'
        },
        {
            palette: 'neutral',
            shade: '9',
            class: 'bg-neutral-9'
        },
        {
            palette: 'neutral',
            shade: '10',
            class: 'bg-neutral-10'
        },
        {
            palette: 'neutral',
            shade: '11',
            class: 'bg-neutral-11'
        },
        {
            palette: 'neutral',
            shade: '12',
            class: 'bg-neutral-12'
        },
        {
            palette: 'neutral',
            shade: '13',
            class: 'bg-neutral-13'
        },
        {
            palette: 'actionPrimary',
            shade: '1',
            class: 'bg-actionPrimary-1'
        },
        {
            palette: 'actionPrimary',
            shade: '2',
            class: 'bg-actionPrimary-2'
        },
        {
            palette: 'actionPrimary',
            shade: '3',
            class: 'bg-actionPrimary-3'
        },
        {
            palette: 'actionPrimary',
            shade: '4',
            class: 'bg-actionPrimary-4'
        },
        {
            palette: 'actionPrimary',
            shade: '5',
            class: 'bg-actionPrimary-5'
        },
        {
            palette: 'actionPrimary',
            shade: '6',
            class: 'bg-actionPrimary-6'
        },
        {
            palette: 'actionPrimary',
            shade: '7',
            class: 'bg-actionPrimary-7'
        },
        {
            palette: 'actionPrimary',
            shade: '8',
            class: 'bg-actionPrimary-8'
        },
        {
            palette: 'actionPrimary',
            shade: '9',
            class: 'bg-actionPrimary-9'
        },
        {
            palette: 'actionPrimary',
            shade: '10',
            class: 'bg-actionPrimary-10'
        },
        {
            palette: 'actionPrimary',
            shade: '11',
            class: 'bg-actionPrimary-11'
        },
        {
            palette: 'actionPrimary',
            shade: '12',
            class: 'bg-actionPrimary-12'
        },
        {
            palette: 'actionPrimary',
            shade: '13',
            class: 'bg-actionPrimary-13'
        },
        {
            palette: 'actionSecondary',
            shade: '1',
            class: 'bg-actionSecondary-1'
        },
        {
            palette: 'actionSecondary',
            shade: '2',
            class: 'bg-actionSecondary-2'
        },
        {
            palette: 'actionSecondary',
            shade: '3',
            class: 'bg-actionSecondary-3'
        },
        {
            palette: 'actionSecondary',
            shade: '4',
            class: 'bg-actionSecondary-4'
        },
        {
            palette: 'actionSecondary',
            shade: '5',
            class: 'bg-actionSecondary-5'
        },
        {
            palette: 'actionSecondary',
            shade: '6',
            class: 'bg-actionSecondary-6'
        },
        {
            palette: 'actionSecondary',
            shade: '7',
            class: 'bg-actionSecondary-7'
        },
        {
            palette: 'actionSecondary',
            shade: '8',
            class: 'bg-actionSecondary-8'
        },
        {
            palette: 'actionSecondary',
            shade: '9',
            class: 'bg-actionSecondary-9'
        },
        {
            palette: 'actionSecondary',
            shade: '10',
            class: 'bg-actionSecondary-10'
        },
        {
            palette: 'actionSecondary',
            shade: '11',
            class: 'bg-actionSecondary-11'
        },
        {
            palette: 'actionSecondary',
            shade: '12',
            class: 'bg-actionSecondary-12'
        },
        {
            palette: 'actionSecondary',
            shade: '13',
            class: 'bg-actionSecondary-13'
        },
        {
            palette: 'actionShop',
            shade: '1',
            class: 'bg-actionShop-1'
        },
        {
            palette: 'actionShop',
            shade: '2',
            class: 'bg-actionShop-2'
        },
        {
            palette: 'actionShop',
            shade: '3',
            class: 'bg-actionShop-3'
        },
        {
            palette: 'actionShop',
            shade: '4',
            class: 'bg-actionShop-4'
        },
        {
            palette: 'actionShop',
            shade: '5',
            class: 'bg-actionShop-5'
        },
        {
            palette: 'actionShop',
            shade: '6',
            class: 'bg-actionShop-6'
        },
        {
            palette: 'actionShop',
            shade: '7',
            class: 'bg-actionShop-7'
        },
        {
            palette: 'actionShop',
            shade: '8',
            class: 'bg-actionShop-8'
        },
        {
            palette: 'actionShop',
            shade: '9',
            class: 'bg-actionShop-9'
        },
        {
            palette: 'actionShop',
            shade: '10',
            class: 'bg-actionShop-10'
        },
        {
            palette: 'actionShop',
            shade: '11',
            class: 'bg-actionShop-11'
        },
        {
            palette: 'actionShop',
            shade: '12',
            class: 'bg-actionShop-12'
        },
        {
            palette: 'actionShop',
            shade: '13',
            class: 'bg-actionShop-13'
        },
        {
            palette: 'actionCritical',
            shade: '1',
            class: 'bg-actionCritical-1'
        },
        {
            palette: 'actionCritical',
            shade: '2',
            class: 'bg-actionCritical-2'
        },
        {
            palette: 'actionCritical',
            shade: '3',
            class: 'bg-actionCritical-3'
        },
        {
            palette: 'actionCritical',
            shade: '4',
            class: 'bg-actionCritical-4'
        },
        {
            palette: 'actionCritical',
            shade: '5',
            class: 'bg-actionCritical-5'
        },
        {
            palette: 'actionCritical',
            shade: '6',
            class: 'bg-actionCritical-6'
        },
        {
            palette: 'actionCritical',
            shade: '7',
            class: 'bg-actionCritical-7'
        },
        {
            palette: 'actionCritical',
            shade: '8',
            class: 'bg-actionCritical-8'
        },
        {
            palette: 'actionCritical',
            shade: '9',
            class: 'bg-actionCritical-9'
        },
        {
            palette: 'actionCritical',
            shade: '10',
            class: 'bg-actionCritical-10'
        },
        {
            palette: 'actionCritical',
            shade: '11',
            class: 'bg-actionCritical-11'
        },
        {
            palette: 'actionCritical',
            shade: '12',
            class: 'bg-actionCritical-12'
        },
        {
            palette: 'actionCritical',
            shade: '13',
            class: 'bg-actionCritical-13'
        },
        {
            palette: 'favorite',
            shade: '1',
            class: 'bg-favorite-1'
        },
        {
            palette: 'favorite',
            shade: '2',
            class: 'bg-favorite-2'
        },
        {
            palette: 'favorite',
            shade: '3',
            class: 'bg-favorite-3'
        },
        {
            palette: 'favorite',
            shade: '4',
            class: 'bg-favorite-4'
        },
        {
            palette: 'favorite',
            shade: '5',
            class: 'bg-favorite-5'
        },
        {
            palette: 'favorite',
            shade: '6',
            class: 'bg-favorite-6'
        },
        {
            palette: 'favorite',
            shade: '7',
            class: 'bg-favorite-7'
        },
        {
            palette: 'favorite',
            shade: '8',
            class: 'bg-favorite-8'
        },
        {
            palette: 'favorite',
            shade: '9',
            class: 'bg-favorite-9'
        },
        {
            palette: 'favorite',
            shade: '10',
            class: 'bg-favorite-10'
        },
        {
            palette: 'favorite',
            shade: '11',
            class: 'bg-favorite-11'
        },
        {
            palette: 'favorite',
            shade: '12',
            class: 'bg-favorite-12'
        },
        {
            palette: 'favorite',
            shade: '13',
            class: 'bg-favorite-13'
        },
        {
            palette: 'success',
            shade: '1',
            class: 'bg-success-1'
        },
        {
            palette: 'success',
            shade: '2',
            class: 'bg-success-2'
        },
        {
            palette: 'success',
            shade: '3',
            class: 'bg-success-3'
        },
        {
            palette: 'success',
            shade: '4',
            class: 'bg-success-4'
        },
        {
            palette: 'success',
            shade: '5',
            class: 'bg-success-5'
        },
        {
            palette: 'success',
            shade: '6',
            class: 'bg-success-6'
        },
        {
            palette: 'success',
            shade: '7',
            class: 'bg-success-7'
        },
        {
            palette: 'success',
            shade: '8',
            class: 'bg-success-8'
        },
        {
            palette: 'success',
            shade: '9',
            class: 'bg-success-9'
        },
        {
            palette: 'success',
            shade: '10',
            class: 'bg-success-10'
        },
        {
            palette: 'success',
            shade: '11',
            class: 'bg-success-11'
        },
        {
            palette: 'success',
            shade: '12',
            class: 'bg-success-12'
        },
        {
            palette: 'success',
            shade: '13',
            class: 'bg-success-13'
        },
        {
            palette: 'error',
            shade: '1',
            class: 'bg-error-1'
        },
        {
            palette: 'error',
            shade: '2',
            class: 'bg-error-2'
        },
        {
            palette: 'error',
            shade: '3',
            class: 'bg-error-3'
        },
        {
            palette: 'error',
            shade: '4',
            class: 'bg-error-4'
        },
        {
            palette: 'error',
            shade: '5',
            class: 'bg-error-5'
        },
        {
            palette: 'error',
            shade: '6',
            class: 'bg-error-6'
        },
        {
            palette: 'error',
            shade: '7',
            class: 'bg-error-7'
        },
        {
            palette: 'error',
            shade: '8',
            class: 'bg-error-8'
        },
        {
            palette: 'error',
            shade: '9',
            class: 'bg-error-9'
        },
        {
            palette: 'error',
            shade: '10',
            class: 'bg-error-10'
        },
        {
            palette: 'error',
            shade: '11',
            class: 'bg-error-11'
        },
        {
            palette: 'error',
            shade: '12',
            class: 'bg-error-12'
        },
        {
            palette: 'error',
            shade: '13',
            class: 'bg-error-13'
        },
        {
            palette: 'benefit',
            shade: '1',
            class: 'bg-benefit-1'
        },
        {
            palette: 'benefit',
            shade: '2',
            class: 'bg-benefit-2'
        },
        {
            palette: 'benefit',
            shade: '3',
            class: 'bg-benefit-3'
        },
        {
            palette: 'benefit',
            shade: '4',
            class: 'bg-benefit-4'
        },
        {
            palette: 'benefit',
            shade: '5',
            class: 'bg-benefit-5'
        },
        {
            palette: 'benefit',
            shade: '6',
            class: 'bg-benefit-6'
        },
        {
            palette: 'benefit',
            shade: '7',
            class: 'bg-benefit-7'
        },
        {
            palette: 'benefit',
            shade: '8',
            class: 'bg-benefit-8'
        },
        {
            palette: 'benefit',
            shade: '9',
            class: 'bg-benefit-9'
        },
        {
            palette: 'benefit',
            shade: '10',
            class: 'bg-benefit-10'
        },
        {
            palette: 'benefit',
            shade: '11',
            class: 'bg-benefit-11'
        },
        {
            palette: 'benefit',
            shade: '12',
            class: 'bg-benefit-12'
        },
        {
            palette: 'benefit',
            shade: '13',
            class: 'bg-benefit-13'
        },
        {
            palette: 'urgency',
            shade: '1',
            class: 'bg-urgency-1'
        },
        {
            palette: 'urgency',
            shade: '2',
            class: 'bg-urgency-2'
        },
        {
            palette: 'urgency',
            shade: '3',
            class: 'bg-urgency-3'
        },
        {
            palette: 'urgency',
            shade: '4',
            class: 'bg-urgency-4'
        },
        {
            palette: 'urgency',
            shade: '5',
            class: 'bg-urgency-5'
        },
        {
            palette: 'urgency',
            shade: '6',
            class: 'bg-urgency-6'
        },
        {
            palette: 'urgency',
            shade: '7',
            class: 'bg-urgency-7'
        },
        {
            palette: 'urgency',
            shade: '8',
            class: 'bg-urgency-8'
        },
        {
            palette: 'urgency',
            shade: '9',
            class: 'bg-urgency-9'
        },
        {
            palette: 'urgency',
            shade: '10',
            class: 'bg-urgency-10'
        },
        {
            palette: 'urgency',
            shade: '11',
            class: 'bg-urgency-11'
        },
        {
            palette: 'urgency',
            shade: '12',
            class: 'bg-urgency-12'
        },
        {
            palette: 'urgency',
            shade: '13',
            class: 'bg-urgency-13'
        },
        {
            palette: 'customer',
            shade: '1',
            class: 'bg-customer-1'
        },
        {
            palette: 'customer',
            shade: '2',
            class: 'bg-customer-2'
        },
        {
            palette: 'customer',
            shade: '3',
            class: 'bg-customer-3'
        },
        {
            palette: 'customer',
            shade: '4',
            class: 'bg-customer-4'
        },
        {
            palette: 'customer',
            shade: '5',
            class: 'bg-customer-5'
        },
        {
            palette: 'customer',
            shade: '6',
            class: 'bg-customer-6'
        },
        {
            palette: 'customer',
            shade: '7',
            class: 'bg-customer-7'
        },
        {
            palette: 'customer',
            shade: '8',
            class: 'bg-customer-8'
        },
        {
            palette: 'customer',
            shade: '9',
            class: 'bg-customer-9'
        },
        {
            palette: 'customer',
            shade: '10',
            class: 'bg-customer-10'
        },
        {
            palette: 'customer',
            shade: '11',
            class: 'bg-customer-11'
        },
        {
            palette: 'customer',
            shade: '12',
            class: 'bg-customer-12'
        },
        {
            palette: 'customer',
            shade: '13',
            class: 'bg-customer-13'
        },
        {
            palette: 'caution',
            shade: '1',
            class: 'bg-caution-1'
        },
        {
            palette: 'caution',
            shade: '2',
            class: 'bg-caution-2'
        },
        {
            palette: 'caution',
            shade: '3',
            class: 'bg-caution-3'
        },
        {
            palette: 'caution',
            shade: '4',
            class: 'bg-caution-4'
        },
        {
            palette: 'caution',
            shade: '5',
            class: 'bg-caution-5'
        },
        {
            palette: 'caution',
            shade: '6',
            class: 'bg-caution-6'
        },
        {
            palette: 'caution',
            shade: '7',
            class: 'bg-caution-7'
        },
        {
            palette: 'caution',
            shade: '8',
            class: 'bg-caution-8'
        },
        {
            palette: 'caution',
            shade: '9',
            class: 'bg-caution-9'
        },
        {
            palette: 'caution',
            shade: '10',
            class: 'bg-caution-10'
        },
        {
            palette: 'caution',
            shade: '11',
            class: 'bg-caution-11'
        },
        {
            palette: 'caution',
            shade: '12',
            class: 'bg-caution-12'
        },
        {
            palette: 'caution',
            shade: '13',
            class: 'bg-caution-13'
        },
        {
            palette: 'highlight',
            shade: '1',
            class: 'bg-highlight-1'
        },
        {
            palette: 'highlight',
            shade: '2',
            class: 'bg-highlight-2'
        },
        {
            palette: 'highlight',
            shade: '3',
            class: 'bg-highlight-3'
        },
        {
            palette: 'highlight',
            shade: '4',
            class: 'bg-highlight-4'
        },
        {
            palette: 'highlight',
            shade: '5',
            class: 'bg-highlight-5'
        },
        {
            palette: 'highlight',
            shade: '6',
            class: 'bg-highlight-6'
        },
        {
            palette: 'highlight',
            shade: '7',
            class: 'bg-highlight-7'
        },
        {
            palette: 'highlight',
            shade: '8',
            class: 'bg-highlight-8'
        },
        {
            palette: 'highlight',
            shade: '9',
            class: 'bg-highlight-9'
        },
        {
            palette: 'highlight',
            shade: '10',
            class: 'bg-highlight-10'
        },
        {
            palette: 'highlight',
            shade: '11',
            class: 'bg-highlight-11'
        },
        {
            palette: 'highlight',
            shade: '12',
            class: 'bg-highlight-12'
        },
        {
            palette: 'highlight',
            shade: '13',
            class: 'bg-highlight-13'
        },
        {
            palette: 'priceSale',
            shade: '1',
            class: 'bg-priceSale-1'
        },
        {
            palette: 'priceSale',
            shade: '2',
            class: 'bg-priceSale-2'
        },
        {
            palette: 'priceSale',
            shade: '3',
            class: 'bg-priceSale-3'
        },
        {
            palette: 'priceSale',
            shade: '4',
            class: 'bg-priceSale-4'
        },
        {
            palette: 'priceSale',
            shade: '5',
            class: 'bg-priceSale-5'
        },
        {
            palette: 'priceSale',
            shade: '6',
            class: 'bg-priceSale-6'
        },
        {
            palette: 'priceSale',
            shade: '7',
            class: 'bg-priceSale-7'
        },
        {
            palette: 'priceSale',
            shade: '8',
            class: 'bg-priceSale-8'
        },
        {
            palette: 'priceSale',
            shade: '9',
            class: 'bg-priceSale-9'
        },
        {
            palette: 'priceSale',
            shade: '10',
            class: 'bg-priceSale-10'
        },
        {
            palette: 'priceSale',
            shade: '11',
            class: 'bg-priceSale-11'
        },
        {
            palette: 'priceSale',
            shade: '12',
            class: 'bg-priceSale-12'
        },
        {
            palette: 'priceSale',
            shade: '13',
            class: 'bg-priceSale-13'
        },
        {
            palette: 'priceRetail',
            shade: '1',
            class: 'bg-priceRetail-1'
        },
        {
            palette: 'priceRetail',
            shade: '2',
            class: 'bg-priceRetail-2'
        },
        {
            palette: 'priceRetail',
            shade: '3',
            class: 'bg-priceRetail-3'
        },
        {
            palette: 'priceRetail',
            shade: '4',
            class: 'bg-priceRetail-4'
        },
        {
            palette: 'priceRetail',
            shade: '5',
            class: 'bg-priceRetail-5'
        },
        {
            palette: 'priceRetail',
            shade: '6',
            class: 'bg-priceRetail-6'
        },
        {
            palette: 'priceRetail',
            shade: '7',
            class: 'bg-priceRetail-7'
        },
        {
            palette: 'priceRetail',
            shade: '8',
            class: 'bg-priceRetail-8'
        },
        {
            palette: 'priceRetail',
            shade: '9',
            class: 'bg-priceRetail-9'
        },
        {
            palette: 'priceRetail',
            shade: '10',
            class: 'bg-priceRetail-10'
        },
        {
            palette: 'priceRetail',
            shade: '11',
            class: 'bg-priceRetail-11'
        },
        {
            palette: 'priceRetail',
            shade: '12',
            class: 'bg-priceRetail-12'
        },
        {
            palette: 'priceRetail',
            shade: '13',
            class: 'bg-priceRetail-13'
        },
        {
            palette: 'marketingBrand',
            shade: '1',
            class: 'bg-marketingBrand-1'
        },
        {
            palette: 'marketingBrand',
            shade: '2',
            class: 'bg-marketingBrand-2'
        },
        {
            palette: 'marketingBrand',
            shade: '3',
            class: 'bg-marketingBrand-3'
        },
        {
            palette: 'marketingBrand',
            shade: '4',
            class: 'bg-marketingBrand-4'
        },
        {
            palette: 'marketingBrand',
            shade: '5',
            class: 'bg-marketingBrand-5'
        },
        {
            palette: 'marketingBrand',
            shade: '6',
            class: 'bg-marketingBrand-6'
        },
        {
            palette: 'marketingBrand',
            shade: '7',
            class: 'bg-marketingBrand-7'
        },
        {
            palette: 'marketingBrand',
            shade: '8',
            class: 'bg-marketingBrand-8'
        },
        {
            palette: 'marketingBrand',
            shade: '9',
            class: 'bg-marketingBrand-9'
        },
        {
            palette: 'marketingBrand',
            shade: '10',
            class: 'bg-marketingBrand-10'
        },
        {
            palette: 'marketingBrand',
            shade: '11',
            class: 'bg-marketingBrand-11'
        },
        {
            palette: 'marketingBrand',
            shade: '12',
            class: 'bg-marketingBrand-12'
        },
        {
            palette: 'marketingBrand',
            shade: '13',
            class: 'bg-marketingBrand-13'
        },
        {
            palette: 'promoPrimary',
            shade: '1',
            class: 'bg-promoPrimary-1'
        },
        {
            palette: 'promoPrimary',
            shade: '2',
            class: 'bg-promoPrimary-2'
        },
        {
            palette: 'promoPrimary',
            shade: '3',
            class: 'bg-promoPrimary-3'
        },
        {
            palette: 'promoPrimary',
            shade: '4',
            class: 'bg-promoPrimary-4'
        },
        {
            palette: 'promoPrimary',
            shade: '5',
            class: 'bg-promoPrimary-5'
        },
        {
            palette: 'promoPrimary',
            shade: '6',
            class: 'bg-promoPrimary-6'
        },
        {
            palette: 'promoPrimary',
            shade: '7',
            class: 'bg-promoPrimary-7'
        },
        {
            palette: 'promoPrimary',
            shade: '8',
            class: 'bg-promoPrimary-8'
        },
        {
            palette: 'promoPrimary',
            shade: '9',
            class: 'bg-promoPrimary-9'
        },
        {
            palette: 'promoPrimary',
            shade: '10',
            class: 'bg-promoPrimary-10'
        },
        {
            palette: 'promoPrimary',
            shade: '11',
            class: 'bg-promoPrimary-11'
        },
        {
            palette: 'promoPrimary',
            shade: '12',
            class: 'bg-promoPrimary-12'
        },
        {
            palette: 'promoPrimary',
            shade: '13',
            class: 'bg-promoPrimary-13'
        },
        {
            palette: 'penny',
            shade: '1',
            class: 'bg-penny-1'
        },
        {
            palette: 'penny',
            shade: '2',
            class: 'bg-penny-2'
        },
        {
            palette: 'penny',
            shade: '3',
            class: 'bg-penny-3'
        },
        {
            palette: 'penny',
            shade: '4',
            class: 'bg-penny-4'
        },
        {
            palette: 'penny',
            shade: '5',
            class: 'bg-penny-5'
        },
        {
            palette: 'penny',
            shade: '6',
            class: 'bg-penny-6'
        },
        {
            palette: 'penny',
            shade: '7',
            class: 'bg-penny-7'
        },
        {
            palette: 'penny',
            shade: '8',
            class: 'bg-penny-8'
        },
        {
            palette: 'penny',
            shade: '9',
            class: 'bg-penny-9'
        },
        {
            palette: 'penny',
            shade: '10',
            class: 'bg-penny-10'
        },
        {
            palette: 'penny',
            shade: '11',
            class: 'bg-penny-11'
        },
        {
            palette: 'penny',
            shade: '12',
            class: 'bg-penny-12'
        },
        {
            palette: 'penny',
            shade: '13',
            class: 'bg-penny-13'
        },
        {
            palette: 'pennyAccents',
            shade: '1',
            class: 'bg-pennyAccents-1'
        },
        {
            palette: 'pennyAccents',
            shade: '2',
            class: 'bg-pennyAccents-2'
        },
        {
            palette: 'pennyAccents',
            shade: '3',
            class: 'bg-pennyAccents-3'
        },
        {
            palette: 'pennyAccents',
            shade: '4',
            class: 'bg-pennyAccents-4'
        },
        {
            palette: 'pennyAccents',
            shade: '5',
            class: 'bg-pennyAccents-5'
        },
        {
            palette: 'pennyAccents',
            shade: '6',
            class: 'bg-pennyAccents-6'
        },
        {
            palette: 'pennyAccents',
            shade: '7',
            class: 'bg-pennyAccents-7'
        },
        {
            palette: 'pennyAccents',
            shade: '8',
            class: 'bg-pennyAccents-8'
        },
        {
            palette: 'pennyAccents',
            shade: '9',
            class: 'bg-pennyAccents-9'
        },
        {
            palette: 'pennyAccents',
            shade: '10',
            class: 'bg-pennyAccents-10'
        },
        {
            palette: 'pennyAccents',
            shade: '11',
            class: 'bg-pennyAccents-11'
        },
        {
            palette: 'pennyAccents',
            shade: '12',
            class: 'bg-pennyAccents-12'
        },
        {
            palette: 'pennyAccents',
            shade: '13',
            class: 'bg-pennyAccents-13'
        },
        {
            palette: 'vipMember',
            shade: '1',
            class: 'bg-vipMember-1'
        },
        {
            palette: 'vipMember',
            shade: '2',
            class: 'bg-vipMember-2'
        },
        {
            palette: 'vipMember',
            shade: '3',
            class: 'bg-vipMember-3'
        },
        {
            palette: 'vipMember',
            shade: '4',
            class: 'bg-vipMember-4'
        },
        {
            palette: 'vipMember',
            shade: '5',
            class: 'bg-vipMember-5'
        },
        {
            palette: 'vipMember',
            shade: '6',
            class: 'bg-vipMember-6'
        },
        {
            palette: 'vipMember',
            shade: '7',
            class: 'bg-vipMember-7'
        },
        {
            palette: 'vipMember',
            shade: '8',
            class: 'bg-vipMember-8'
        },
        {
            palette: 'vipMember',
            shade: '9',
            class: 'bg-vipMember-9'
        },
        {
            palette: 'vipMember',
            shade: '10',
            class: 'bg-vipMember-10'
        },
        {
            palette: 'vipMember',
            shade: '11',
            class: 'bg-vipMember-11'
        },
        {
            palette: 'vipMember',
            shade: '12',
            class: 'bg-vipMember-12'
        },
        {
            palette: 'vipMember',
            shade: '13',
            class: 'bg-vipMember-13'
        },
        {
            palette: 'vipBlue',
            shade: '1',
            class: 'bg-vipBlue-1'
        },
        {
            palette: 'vipBlue',
            shade: '2',
            class: 'bg-vipBlue-2'
        },
        {
            palette: 'vipBlue',
            shade: '3',
            class: 'bg-vipBlue-3'
        },
        {
            palette: 'vipBlue',
            shade: '4',
            class: 'bg-vipBlue-4'
        },
        {
            palette: 'vipBlue',
            shade: '5',
            class: 'bg-vipBlue-5'
        },
        {
            palette: 'vipBlue',
            shade: '6',
            class: 'bg-vipBlue-6'
        },
        {
            palette: 'vipBlue',
            shade: '7',
            class: 'bg-vipBlue-7'
        },
        {
            palette: 'vipBlue',
            shade: '8',
            class: 'bg-vipBlue-8'
        },
        {
            palette: 'vipBlue',
            shade: '9',
            class: 'bg-vipBlue-9'
        },
        {
            palette: 'vipBlue',
            shade: '10',
            class: 'bg-vipBlue-10'
        },
        {
            palette: 'vipBlue',
            shade: '11',
            class: 'bg-vipBlue-11'
        },
        {
            palette: 'vipBlue',
            shade: '12',
            class: 'bg-vipBlue-12'
        },
        {
            palette: 'vipBlue',
            shade: '13',
            class: 'bg-vipBlue-13'
        },
        {
            palette: 'vipGold',
            shade: '1',
            class: 'bg-vipGold-1'
        },
        {
            palette: 'vipGold',
            shade: '2',
            class: 'bg-vipGold-2'
        },
        {
            palette: 'vipGold',
            shade: '3',
            class: 'bg-vipGold-3'
        },
        {
            palette: 'vipGold',
            shade: '4',
            class: 'bg-vipGold-4'
        },
        {
            palette: 'vipGold',
            shade: '5',
            class: 'bg-vipGold-5'
        },
        {
            palette: 'vipGold',
            shade: '6',
            class: 'bg-vipGold-6'
        },
        {
            palette: 'vipGold',
            shade: '7',
            class: 'bg-vipGold-7'
        },
        {
            palette: 'vipGold',
            shade: '8',
            class: 'bg-vipGold-8'
        },
        {
            palette: 'vipGold',
            shade: '9',
            class: 'bg-vipGold-9'
        },
        {
            palette: 'vipGold',
            shade: '10',
            class: 'bg-vipGold-10'
        },
        {
            palette: 'vipGold',
            shade: '11',
            class: 'bg-vipGold-11'
        },
        {
            palette: 'vipGold',
            shade: '12',
            class: 'bg-vipGold-12'
        },
        {
            palette: 'vipGold',
            shade: '13',
            class: 'bg-vipGold-13'
        },
        {
            palette: 'vipPlatinum',
            shade: '1',
            class: 'bg-vipPlatinum-1'
        },
        {
            palette: 'vipPlatinum',
            shade: '2',
            class: 'bg-vipPlatinum-2'
        },
        {
            palette: 'vipPlatinum',
            shade: '3',
            class: 'bg-vipPlatinum-3'
        },
        {
            palette: 'vipPlatinum',
            shade: '4',
            class: 'bg-vipPlatinum-4'
        },
        {
            palette: 'vipPlatinum',
            shade: '5',
            class: 'bg-vipPlatinum-5'
        },
        {
            palette: 'vipPlatinum',
            shade: '6',
            class: 'bg-vipPlatinum-6'
        },
        {
            palette: 'vipPlatinum',
            shade: '7',
            class: 'bg-vipPlatinum-7'
        },
        {
            palette: 'vipPlatinum',
            shade: '8',
            class: 'bg-vipPlatinum-8'
        },
        {
            palette: 'vipPlatinum',
            shade: '9',
            class: 'bg-vipPlatinum-9'
        },
        {
            palette: 'vipPlatinum',
            shade: '10',
            class: 'bg-vipPlatinum-10'
        },
        {
            palette: 'vipPlatinum',
            shade: '11',
            class: 'bg-vipPlatinum-11'
        },
        {
            palette: 'vipPlatinum',
            shade: '12',
            class: 'bg-vipPlatinum-12'
        },
        {
            palette: 'vipPlatinum',
            shade: '13',
            class: 'bg-vipPlatinum-13'
        }
    ]
});
exports.backgroundPaletteVariants = __webpack_exports__.backgroundPaletteVariants;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "backgroundPaletteVariants"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
